// @ts-strict-ignore
import RichContentField from '@components/_content-page/RichContentField'
import { Box, Button, Container, Image, StyledBox } from '@components/gassan-ui'
import { Heading } from '@components/gassan-ui/Typography/Heading'
import { cn } from '@lib/cn'
import { getKontentImage } from '@lib/kontent'
import { HomepageCbMygassanMembership } from '@lib/kontent/models/HomepageCbMygassanMembership'
import Link from 'next/link'
import { rem } from 'polished'
import { FC } from 'react'

type HomepageMyGassanSectionProps = HomepageCbMygassanMembership

export const HomepageMyGassanSection: FC<HomepageMyGassanSectionProps> = ({
  title,
  rich_content,
  button_text,
  button_url,
  content_background_color,
  mobile_image,
  desktop_image,
}) => {
  const bg =
    content_background_color?.value[0]?.name === 'dark'
      ? 'shades.700'
      : content_background_color?.value[0]?.name === 'white'
      ? 'white'
      : content_background_color?.value[0]?.name === 'pampas'
      ? 'pampas'
      : 'pampasLight'
  const textColor = bg === 'shades.700' ? 'white' : 'inherit'
  return (
    <div
      className={cn(
        'relative mb-8 flex items-end pb-20 pt-[55%]',
        'sm:mb-16 sm:pt-[50%]',
        'lg:mb-0 lg:items-center lg:pt-20',
        'huge:py-[9.5rem]',
      )}
    >
      <div className={cn('absolute top-0 -z-[1] h-[55%] w-full', 'sm:h-[80%]', 'lg:h-full')}>
        <Image
          className="h-full w-full"
          sources={[
            getKontentImage(mobile_image.value[0].url, { width: 600 }),
            getKontentImage(mobile_image.value[0].url, { width: 500 }),
            getKontentImage(desktop_image.value[0].url, { width: 1400 }),
            getKontentImage(desktop_image.value[0].url, { width: 2000 }),
          ]}
          placeholder={getKontentImage(mobile_image.value[0].url, { width: 50 })}
          alt={desktop_image.value[0].description}
        />
      </div>
      <div className="relative z-[2] w-full">
        <Container maxWidth={rem(1450)}>
          <Box
            bg={bg}
            p={{ _: '1.5rem', small: '3rem', xlarge: '4rem' }}
            maxWidth={{ _: '', small: '37rem' }}
            ml={{
              _: 'auto',
              large: 'right',
            }}
            mr={{ _: 'auto', large: 'initial' }}
          >
            {title.value && (
              <Heading variant="h2" as="h2" className="mb-4 lg:mb-6" color={textColor}>
                {title.value}
              </Heading>
            )}
            <RichContentField
              {...rich_content}
              textColor={bg === 'shades.700' ? 'white' : 'black'}
            />
            {button_text && button_url && (
              <StyledBox className={cn('mt-6 inline-block', 'lg:mt-8')}>
                <Link href={button_url.value} passHref>
                  <Button variant="dark" as="link">
                    {button_text.value}
                  </Button>
                </Link>
              </StyledBox>
            )}
          </Box>
        </Container>
      </div>
    </div>
  )
}
